<template>
  <fts-design-modal
    :backdrop="!submitting"
    :escape-event="false"
    :disabled-close="submitting"
    class="fts-widget-chart-design-modal"
    ref="ftsWidgetChartDesignModal"
  >
    <!-- title -->
    <template #title>
      <div class="design-modal-header-std__title">
        <font-awesome-icon :icon="['fas', 'chart-simple']" class="design-modal-header-icon" />
        <div class="design-modal-header-name design-modal-header-name--flex-1">Chart</div>
      </div>
    </template>
    <!-- description -->
    <template #description>
      <span class="design-modal-header-tag">Widget</span>
    </template>
    <!-- body -->
    <template #body>
      <fts-widget-chart-design
        :modules="modules"
        :chart-data.sync="formData"
        ref="chart-design"
      />
    </template>
    <!-- footer:left -->
    <template #footerLeft>
      <fts-btn text icon :disabled="submitting" @click="remove" v-if="isExist">
        <font-awesome-icon :icon="['far', 'trash-alt']" />
      </fts-btn>
    </template>
    <!-- footer:right -->
    <template #footerRight>
      <!-- cancel -->
      <fts-btn text :disabled="submitting" @click="beforeClose">Cancel</fts-btn>
      <!-- done -->
      <fts-btn outline color="primary" :loading="submitting" @click="done">
        <font-awesome-icon :icon="['fas', 'check']" />Ok
      </fts-btn>
    </template>
  </fts-design-modal>
</template>

<script>
import changesets from "diff-json";

import FTSDesignModal from "../../design/FTSDesignModal";
import FTSBtn from "../../elements/FTSBtn";
import FTSWidgetChartDesign from './FTSWidgetChartDesign';

export default {
  components: {
    "fts-design-modal": FTSDesignModal,
    "fts-btn": FTSBtn,
    "fts-widget-chart-design": FTSWidgetChartDesign
  },
  props: {
    modules: Array,
    list: Array
  },
  data: () => ({
    formData: null,
    originalData: null,
    resolve: null,
    submitting: false
  }),
  methods: {
    async show(formData) {
      this.formData = _.cloneDeep(formData);

      return new Promise(async resolve => {
        this.resolve = resolve;
        this.$refs.ftsWidgetChartDesignModal.show({
          beforeCloseHandler: () => {
            const diff = changesets.diff(this.formData, this.originalData);
            if (diff && diff.length) {
              this.$modal.show("dialog", {
                title: "Confirm discard changes",
                text: "Discard all changes?",
                buttons: [
                  { title: "Cancel" },
                  {
                    title: "Discard",
                    default: true,
                    handler: () => {
                      this.$modal.hide("dialog");
                      this.reset();
                    }
                  }
                ]
              });
            } else {
              this.reset();
            }
          }
        });

        this.$nextTick(() => {
          this.originalData = _.cloneDeep(this.formData);
        });
      });
    },
    beforeClose() {
      this.$refs.ftsWidgetChartDesignModal.beforeClose();
    },
    done() {
      const validate = this.$refs['chart-design'].validateForm();
      if (!validate.$invalid) {
        this.submitting = true;
        const formData = _.cloneDeep(this.formData);
        this.resolve && this.resolve(formData);
      }
    },
    remove() {
      this.$modal.show("dialog", {
        title: "Confirmation",
        text: `Delete Chart?`,
        buttons: [
          { title: "Cancel" },
          {
            title: "Delete",
            default: true,
            handler: () => {
              this.$modal.hide("dialog");
              this.resolve && this.resolve(true);
              this.reset();
            }
          }
        ]
      });
    },
    reset() {
      this.$refs.ftsWidgetChartDesignModal.close();
      Object.assign(this.$data, this.$options.data.apply(this));
    }
  },
  computed: {
    isExist() {
      return this.list && this.list.some(x => x.id === this.formData.id);
    }
  }
};
</script>

<style lang="scss" scoped>
@use "./src/components/dashboard/design/scss/style";
</style>